// @flow

// force flow to type check this file - https://github.com/zapier/zapier/pull/31127
import React from 'react'; /* eslint-disable-line no-unused-vars */

import { AppBanner } from '@zapier/services';
import { Colors } from '@zapier/theme';
import { LogoImage } from '@zapier/common-components';
import { css, jsx } from '@emotion/core';

import type { SelectItemType } from '@zapier/common-components';

/** @jsx jsx */

type Props = {
  item: SelectItemType,
};

const getServiceItemStyles = (disabled?: boolean) =>
  css(
    {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    },
    disabled && {
      opacity: 0.5,
      cursor: 'default',
    }
  );

const serviceBannerStyles = {
  marginLeft: 'auto',
};

const serviceDescriptionStyles = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  marginLeft: '10px',
};

const serviceInfoStyles = {
  display: 'flex',
  flexDirection: 'row',
};

const serviceNameStyles = {
  fontSize: '14px',
  color: Colors.theme.secondary.text,
};

/** Renders a single service item in the dropdown. */
const MenuItemComponent = ({ item }: Props) => (
  <div css={getServiceItemStyles(item.isDisabled)}>
    <div css={serviceInfoStyles}>
      <LogoImage app={item.key} size={32} />
      <div css={serviceDescriptionStyles}>
        <div css={serviceNameStyles}>{item.name}</div>
        <div>{item.subtitle}</div>
      </div>
    </div>
    <div css={serviceBannerStyles}>
      <AppBanner banner={item.banner} />
    </div>
  </div>
);

export default MenuItemComponent;
